import React from 'react'
import { Helmet } from 'react-helmet-async'

export const SITE_URL = 'https://clinf.com'
const SITE_NAME = 'CLI - Bridge the Gap'
const OG_IMAGE = `${SITE_URL}/og-image.png`

const Seo = ({ title, description, path = '/', noindex = false }) => {
  const url = `${SITE_URL}${path === '/' ? '/' : path}`
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <link rel='canonical' href={url} />
      {noindex && <meta name='robots' content='noindex' />}

      <meta property='og:type' content='website' />
      <meta property='og:site_name' content={SITE_NAME} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:url' content={url} />
      <meta property='og:image' content={OG_IMAGE} />

      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={OG_IMAGE} />
    </Helmet>
  )
}

export default Seo
